import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchUpdateGiveawayMain = async (id, payload) => {
  const { data } = await SigliveServiceV1({
    method: 'PATCH',
    url: `/briefs/giveaways/main/${id}`,
    data: payload,
  });

  return data?.data;
};

export default patchUpdateGiveawayMain;
